<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import PartnersLayout from '@/Layouts/PartnersLayout.vue'

defineOptions({ layout: PartnersLayout })
const { t } = useI18n()
</script>

<template>
  <Head>
    <title>{{ t('partners.check_email.head_title') }}</title>
  </Head>
  <h1 class="c-title">
    {{ t('partners.check_email.title') }}
  </h1>
  <p class="c-body">
    {{ t('partners.check_email.body') }}
  </p>
  <p class="c-hint">
    {{ t('partners.check_email.hint') }}
  </p>
</template>

<style scoped>
.c-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.c-body { color: var(--inkSoft); font-size: 0.9375rem; line-height: 1.5; margin: 0 0 0.75rem; }
.c-hint { color: var(--muted); font-size: 0.8125rem; }
</style>
